export const blobToFile = (blob: Blob, fileName: string, type: string) => {
  return new File([blob], fileName, { type, lastModified: Date.now() });
};
